"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f1089 = void 0;
exports.f1089 = {
    "саха тыла": [
        6664
    ],
    "саха": [
        6664
    ],
    "српски": [
        7088,
        7089,
        7091,
        7099
    ]
};
